import _ from 'lodash';

export default function getObjectDifferenceByDeepEqual(source, initialSource) {
  const data = {};
  Object.keys(source).forEach((dataKey) => {
    const value = source[dataKey];
    const initialValue = initialSource[dataKey];
    if (dataKey === 'fst' || dataKey === 'showUnavailableHotels') {
      data[dataKey] = value;
      return true;
    }

    if (Array.isArray(value) && !_.isEqual(value, initialValue)) {
      data[dataKey] = value;
      return true;
    }

    if (value && initialValue && typeof value === 'object') {
      const innerObject = getObjectDifferenceByDeepEqual(value, initialValue);
      if (Object.keys(innerObject).length) {
        data[dataKey] = innerObject;
      }
      return true;
    }

    if (!_.isEqual(value, initialValue)) {
      data[dataKey] = value;
    }

    return data;
  });
  return data;
}
